exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#newReviewList .popover-new-container {\n  top: -8px !important;\n}\n#newReviewList .reply-popover {\n  left: 320px !important;\n}\n#newReviewList .add-note-popover {\n  left: -11px !important;\n}\n", "", {"version":3,"sources":["/app/src/pages/reviews/BusinessReviewsListNew.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;CACtB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB","file":"BusinessReviewsListNew.vue","sourcesContent":["\n#newReviewList .popover-new-container {\n  top: -8px !important;\n}\n#newReviewList .reply-popover {\n  left: 320px !important;\n}\n#newReviewList .add-note-popover {\n  left: -11px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d2790124","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/reviews/BusinessReviewsListNew.vue
// module id = 6ZCc
// module chunks = 4